import { gql } from '@apollo/client';

export const QUERY_DAILY_HUB_OPERATION_DETAIL_LIST = gql`
    query QueryDailyHubOperationDetailList($input: DailyHubOperationDetailPageRequestInput!) {
        queryDailyHubOperationDetailList(input: $input) {
            content {
                id
                orderId
                trackingNumber
                hubId
                hubName
                customerName
                businessType
                isNextDayHandover
                clientName
                arrivalTime
                departureTime
                deliveryTime
                wrongSortType
                shouldDeliveryAddress
                actualDeliveryAddress
                currentNoUpdateHours
                lastTrackingUpdateTime
                maxNoUpdateHours
                noUpdateWrongSortEverStatus
                statDate
                overallStatus
                lastSortOperationAccountName
                lastSortOperationAccountRole
                wrongLineMissortScanDriverName
                wrongLineMissortScanDspName
                lastMileServiceProviderName
                sortErrorType
                missortedLogicType
                lastSortingHubScanAccountName
                lastSortingHubScanTime
                lastSortingHubScanTrackingEvent
                lastSortingHubScanBagNumber
                isLastBaggingCorrect
                lastBaggingBagNumber
                lastSortOperationTime
                extSortingRule
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
